var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenantOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 60,
    viewBox: "0 0 28 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 20.3979H10.3925C5.62151 20.3979 1.56517 23.9767 0.969384 28.7477L0.0149949 36.5008C-0.10399 37.4552 0.491774 38.4096 1.56596 38.6475C2.99713 39.0053 4.42902 39.1243 5.86023 39.3631L6.93361 57.4947C7.0526 58.9259 8.24579 60.0001 9.67696 60.0001H17.9079C19.339 60.0001 20.5321 58.9268 20.6512 57.4947L21.7246 39.3631C23.1558 39.1243 24.5877 38.8863 26.0189 38.6475C26.9733 38.4087 27.6888 37.4543 27.5698 36.5008L26.4965 28.7477C25.8999 23.9767 21.8443 20.3979 17.0725 20.3979H17.0723Z",
    fill: "#212121",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6779 8.94641C22.6779 13.8872 18.6732 17.8928 13.7316 17.8928C8.7908 17.8928 4.78516 13.8872 4.78516 8.94641C4.78516 4.0048 8.7908 0 13.7316 0C18.6732 0 22.6779 4.0048 22.6779 8.94641Z",
    fill: "#212121",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantOn);
export default __webpack_public_path__ + "static/media/tenant_on.ef6eb09e3a731a8bb130e14d3632c4e8.svg";
export { ForwardRef as ReactComponent };